module.exports = __webpack_public_path__ + "img/Speaker=Lakey Hu.14862b4b.png";